import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Navigations } from '../shared/models/navigation.interface';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-auth',
    templateUrl: './auth.component.html',
    styleUrl: './auth.component.scss'
})
export class AuthComponent implements OnInit {
  loading = true;
  redirectUrl = Navigations.TIME_TRIVIA.path;
  private destroyRef = inject(DestroyRef);

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authSrv: AuthService,
  ) { }

  ngOnInit(): void {
    const params = this.route.snapshot.queryParams;
    this.authenticate(params);
  }

  authenticate(params: any) {
    const tokens = {
      token: params.token,
      pin_token: params['pin-token'],
    }   
    if(tokens.token && tokens.pin_token) {
      this.loading = true;
      this.authSrv.getUserProfile(tokens)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: (_) => { 
            const redirectUrl = params.redirect_url || this.redirectUrl;          
            this.authSrv.setUserLoggedIn(tokens);
            this.router.navigate([`/${redirectUrl}`]);
          }, 
          error: (err) => {
            console.log('auth-err',err);
            this.loading = false;
          }
        })
    } else {
      this.loading = false;
    }
  }
}
